export enum HeaderVariant {
  Transparent = "transparent",
  Gray = "Gray",
}
